/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component} from "@angular/core";

@Component({
  templateUrl: './people.component.html'
})
export class PeopleComponent {

}
